export const CHOOSE_HAT_COLOR = ".pplr-swatch-main span";
export const SWATCHES = ".pplrgcolor.pplr_thumb_image.pplr-swatch-main [data-val]";
